
























































































import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';

import ClipboardCopyMixin from "../../logic/helpers/ClipboardCopyMixin";
import { TargetCardInfo } from "./types";

@Component({
})
export default class TargetCard extends Mixins(ClipboardCopyMixin) {
  @Prop() target!: TargetCardInfo

  @Prop({ type: Boolean, required: false, default: false }) hasDeleteButton!: boolean

  @Prop({ type: Boolean, required: false, default: false }) hasRefreshButton!: boolean

  @Emit()
  deleteClick() {
    return this.target
  }

  @Emit()
  refreshClick() {
    return this.target
  }
}
